import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import endpoints from '../../../../config/endpoints';
import { Sidebar } from '../../../../layouts/Sidebar';
import { setLoading } from '../../../../services/reducers/homeSlice';
import restApi from '../../../../services/restApi';
import store from '../../../../services/store';
import alertHandler from '../../../../utils/alertHandler';
import tools from '../../../../utils/tools';
import Attributes from '../../../Product/Manage/Attributes';
import Basic from '../../../Product/Manage/Basic';
import FitFor from '../../../Product/Manage/FitFor';
import Specifics from '../../../Product/Manage/Specifics';
import Prices from './Prices';

const PackingManage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [title, setTitle] = useState('');
  const [tab, setTab] = useState('basic');
  const [form, setForm] = useState<any>();
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [tags, setTags] = useState([]);
  const [parts, setParts] = useState([]);
  const [images, setImages] = useState([]);
  const [specifics, setSpecifics] = useState([]);
  const [cars, setCars] = useState([]);
  const [years, setYears] = useState([]);
  const [colors, setColors] = useState([]);
  const [stores, setStores] = useState([]);
  const { id: paramId } = useParams();
  const isEdit = window.location.pathname.includes('edit');
  const tabTitles = {
    basic: 'اطلاعات اولیه',
    specifics: 'مشخصات فنی',
    attributes: 'شاخص ها',
    fitFor: 'مناسب برای',
  };

  const content = () => {
    switch (tab) {
      case 'basic':
        return <Prices form={form} setForm={setForm} stores={stores} brands={brands} cars={cars}/>;
      case 'specifics':
        return <Specifics form={form} setForm={setForm} specifics={specifics} parts={parts} fetchBrand={fetchPart} />;
      case 'attributes':
        return <Attributes form={form} setForm={setForm} specifics={specifics} images={images} colors={colors}/>;
      case 'fitFor':
        return <FitFor form={form} setForm={setForm} cars={cars} years={years}/>;
      default:
        return <></>;
    }
  };

  const fetchPart = async (id) => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.part.single + id).get();

    if (res.code == 200) {
      setTitle(prev => res.data.title);
      setSpecifics(res.data?.specifics);
    }

    dispatch(setLoading(false));
  };

  const submit = async () => {
    dispatch(setLoading(true));

    let storeId = form?.storeId
    if(!form.storeId && form?.newStore?.phoneNumber && form.newStore.title){
      const res = await restApi(endpoints.store.basic).post(tools.extractor(form.newStore, ['title', 'phoneNumber', 'address']))
      storeId = res.data?.id
    }

    const res = await Promise.all([
      // isEdit && restApi(endpoints.orderProduct.update + paramId).put({ ...tools.extractor(form, ['price', 'buyPrice']), storeId: storeId }),
      restApi(endpoints.product.specifics + form?.productId).put(tools.extractor(form, ['specifics', 'partId'])),
      restApi(endpoints.product.fitFors + form?.productId).put(tools.extractor(form, ['fitFors'])),
      restApi(endpoints.product.attributes + form?.productId).put(tools.extractor(form, ['attributes'])),
    ]);
    res.push(await restApi(endpoints.orderProduct.variants + paramId).put(tools.extractor(form, ['variations'])),)
    alertHandler(res, 'محصول با موفقیت ویرایش شد');

    dispatch(setLoading(false));
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await Promise.all([
      restApi(endpoints.brand.index).get(),
      restApi(endpoints.part.index).get(),
      restApi(endpoints.car.index).get(),
      restApi(endpoints.year).get(),
      restApi(endpoints.color.index).get(),
      restApi(endpoints.store.index).get(),
      paramId && restApi(endpoints.orderProduct.single + paramId).get(),
    ]);

    setBrands(res[0].data);
    setParts(res[1].data);
    setCars(res[2].data);
    setYears(res[3].data);
    setColors(res[4].data);
    setStores(res[5].data);

    if (paramId) {
      setTitle(res[6].data?.product?.title);

      await fetchPart(res[6].data?.partId || res[6].data?.product?.partId);

      // format specifics
      const newSpecifics = {};

      res[6].data?.product?.specificProducts?.map((e) => {
        newSpecifics[e.specificSlug] = {
          value: e.specificValueSlug,
          inTitle: e.inTitle || false,
          isAttribute: e.isAttribute || false,
          sort: e.sort,
        };
      });

      // format attributes
      const newAttributes = {};

      res[6].data?.product?.attributes?.map((e, index) => {
        const newAttributeSpecifics = {};
        e.attributeSpecifics.map((v) => {
          newAttributeSpecifics[v.specificSlug] = v.specificValueSlug;
        });
        newAttributes[index] = {
          color: e.colorId,
          discountPrice: e.discountPrice,
          price: e.price,
          status: e.status,
          specifics: newAttributeSpecifics
        };
      });

      let newVariations = res[6].data?.variations;

      if (!newVariations.length){
        newVariations = [
          {
            buyPrice: 0,
            sellPrice: 0,
            storeId: '',
            brandId: '',
            carId: res[6].data?.carId,
            productId: res[6].data?.productId
          }
        ]
      }
      console.log(newVariations);
      setForm({
        buyPrice: res[6].data?.buyPrice,
        price: res[6].data?.price || res[6].data?.product?.price,
        storeId: res[6].data?.storeId,
        productId: res[6].data?.productId,
        brandId: res[6].data?.brandId,
        partId: res[6].data?.partId || res[6].data?.product?.partId,
        carId: res[6].data?.carId,
        fitFors: res[6].data?.product?.fitFors?.map(e => ({
          car: e.carId,
          year: e.yearId,
          toYear: e.toYearId
        })),
        variations: newVariations,
        specifics: newSpecifics,
        attributes: newAttributes,
      });
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const formatTitle = () => {
    let newTitle = '';

    if (form?.partId) {
      newTitle = parts.find(e => e.id == form?.partId)?.title;
    }

    if (form?.specifics) {
      const newSpecifics: any[] = Object.values(form?.specifics).filter((e: any) => e.inTitle); //Apparently I created a variable for easier understanding

      const specificValues = [];
      specifics.map(i => i.specificValues?.map(j => specificValues.push(j)));
      newSpecifics.sort((a,b) => Number(a.sort || Number.MAX_SAFE_INTEGER) - Number(b.sort || Number.MAX_SAFE_INTEGER)).map((e) => {
        const valueTitle = specificValues?.find(i => i.slug == (e?.value || ''))?.title;
        if (valueTitle) {
          newTitle += ' ' + valueTitle;
        }
      });
    }

    if (form?.carId) {
      newTitle += ' ' + cars.find(e => e.id == form?.carId)?.slug.replaceAll('/', ' ');
      // newTitle += ' ' + cars.find(e => e.id == form?.carId)?.title;
    }

    if (form?.brandId) {
      newTitle += ' ' + brands.find(e => e.id == form?.brandId)?.title;
    }

    setForm(prev => ({
      ...prev,
      title: newTitle
    }));
  };

  useEffect(() => {
    formatTitle();
  }, [form?.brandId, form?.carId, form?.specifics, form?.partId]);

  return (
    <>
      <main className="dashboardBody">
        <Sidebar/>
        <div className="dashBoardMain main">
          <div className="addInfoHeader">
            <div className="buttonContainer keepRight">
              <button className="dashboardHeader keepRight" onClick={() => submit()}>
                <p>{isEdit ? 'ویرایش' : 'ایجاد'} محصول</p>
              </button>
            </div>
            <span>
          <h1 className="sideBarTitle">بازگشت به صفحه محصولات</h1>
           <h1 className="dashBoardTitle">{isEdit ? 'ویرایش محصول' : 'افزودن محصول جدید'}</h1>
        </span>
            <i className="backAdd" onClick={() => navigate('/product')}></i>
          </div>
          <section className="center">
            <h1>{form?.title}</h1>
            <div className="dashTabs">
              {Object.entries(tabTitles).map(([key, value]) =>
                  <span className={`ordersTag ${key == tab ? 'activeTab' : ''}`} onClick={() => setTab(key)}>
                {value}
              </span>
              )}
            </div>
            {content()}
          </section>
        </div>
      </main>
    </>
  );

};
export default PackingManage;